import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24b5e4ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "subtitulo" }
const _hoisted_2 = {
  key: 0,
  class: "erro"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createTextVNode(" Subtítulo do formulário "),
      _withDirectives(_createElementVNode("textarea", {
        id: "subtituloFormulario",
        name: "subtituloFormulario",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subTituloString) = $event)),
        onFocusout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.digitou && _ctx.digitou(...args))),
        required: ""
      }, null, 544), [
        [_vModelText, _ctx.subTituloString]
      ]),
      (_ctx.erro)
        ? (_openBlock(), _createElementBlock("article", _hoisted_2, _toDisplayString(_ctx.erro), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}